import BulkOperationResultDisplay from './BulkOperationResultDisplay';

export default BulkOperationResultDisplay;
